import styled from 'styled-components';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';

const ScrollableModalBody = styled(ModalBody)`
  max-height: 400px; /* Set maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
`;

interface ExcessPermissionsModalProps {
  handleClose: () => void;
  excessPermissionsList: string[];
}

export default ({ handleClose, excessPermissionsList }: ExcessPermissionsModalProps) => (
  <ModalContainer data-test='excess-permissions-modal'>
    <ModalHeader data-test='excess-permissions-modal__header' onClose={handleClose}>
      Excess Permissions
    </ModalHeader>

    <ScrollableModalBody>
      {excessPermissionsList.map((permission, index) => (
        <p key={index}>{permission}</p>
      ))}
    </ScrollableModalBody>
  </ModalContainer>
);
